
import Vue from 'vue';
import * as TelliqService from '@/services/telliq.service';
import { find } from 'lodash';
import { Machine } from '@/models/bookings';
import { emitter } from '@/utils/constants';

export default Vue.extend({
  async created() {
    this.handleRedirect();
  },

  methods: {
    async handleRedirect() {
      const vehicle_name = this.$route.query.vehicle;
      if (!vehicle_name || typeof vehicle_name !== 'string') {
        // malformed QR code -> notify user
        emitter.emit('notify', {
          text: this.$t('bookings.snackbars.malformed_qr_code'),
          color: 'info',
        });
        this.redirectHome();
        return;
      }

      const vehicle = await this.getMachineByName(vehicle_name);
      if (!vehicle) {
        // vehicle not found -> notify user
        emitter.emit('notify', {
          text: this.$t('bookings.snackbars.vehicle_not_found'),
          color: 'info',
        });
        this.redirectHome();
        return;
      }

      // redirect to check-in booking
      await this.$router.push('/booking/check-in/' + vehicle.id);
    },

    redirectHome() {
      this.$router.push('/');
    },

    async getMachineByName(machine_name: string): Promise<Machine | undefined> {
      const machines = await TelliqService.getMachines();
      return find(machines, { name: machine_name });
    },
  },
});
